import reducer from "./reducer";
export { default as AssetsDiscountsCreation } from "./components/index";
export { default as assetsDiscountsCreationReducerName } from "./constants";
export default reducer;
